import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';

/**
 * Component that automatically updates the document title based on the current route.
 * Place this component in your app layout to enable automatic title updates.
 *
 * To set a title for a route, add a `handle` property with a `title` field:
 * @example
 * {
 *   path: '/orders',
 *   element: <OrdersPage />,
 *   handle: { title: 'Orders' }
 * }
 */
export function DocumentTitleUpdater() {
	const matches = useMatches();

	useEffect(() => {
		// Find the deepest route match with a title in its handle
		const matchWithTitle = [...matches].reverse().find((match) => {
			const handle = match.handle as { title?: string } | undefined;
			return handle?.title;
		});

		if (matchWithTitle) {
			const handle = matchWithTitle.handle as { title: string };
			document.title = `Admin Portal | ${handle.title}`;
		} else {
			// Fallback to default title if no route has a title
			document.title = 'Admin Portal';
		}
	}, [matches]);

	return null; // This component doesn't render anything
}
